import React, { useState } from 'react';
import {
  IconWrapper,
  NavigationLabelWrapper,
  NavigationMenuWrapper,
} from './NavigationMenu.style';
import { ArrowUp } from '../../../global/icons/arrowUp/ArrowUp';
import { ArrowDown } from '../../../global/icons/arrowDown/ArrowDown';

interface NavigationMenuProps {
  label: React.ReactNode;
  menuDropdown: React.ReactNode;
}

export const NavigationMenu: React.FC<NavigationMenuProps> = ({
  label,
  menuDropdown,
}) => {
  const [isShowMenuDropdown, setIsShowMenuDropdown] = useState(false);
  const handleShowMenuDropdown = () => {
    setIsShowMenuDropdown((isShowMenuDropdown) => !isShowMenuDropdown);
  };
  return (
    <NavigationMenuWrapper>
      <NavigationLabelWrapper>
        <div>{label}</div>
        <IconWrapper
          data-testid="icon-wrapper"
          onClick={handleShowMenuDropdown}
        >
          {isShowMenuDropdown ? <ArrowUp /> : <ArrowDown />}
        </IconWrapper>
      </NavigationLabelWrapper>
      <div>{isShowMenuDropdown && menuDropdown}</div>
    </NavigationMenuWrapper>
  );
};
